import { shouldPolyfill } from '@formatjs/intl-locale/should-polyfill.js';

import { loadPolyfill } from './polyfill';

const polyfill = (() => {
	const promises: Partial<Record<string, Promise<void>>> = {};

	return async function innerPolyfill(locale: string) {
		if (promises[locale]) {
			return promises[locale];
		}

		promises[locale] = loadPolyfill(locale, LOCALE_CHECKS.dependencies);
		return promises[locale];
	};
})();

const LOCALE_CHECKS = {
	name: 'locale' as const,
	dependencies: [],
	// variants are not supported in most browsers yet, and we don't need them
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	checkNativeIntlFeature: (): boolean => !!window.Intl && !shouldPolyfill({ ignoreVariants: true }),
	polyfill,
};

export const INTL_LOCALE_CHECKS = [LOCALE_CHECKS];
